"use client";

import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

type MainLoaderProps = {
  title?: string;
  subtitle?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizeStyles = {
  sm: {
    spinner: "h-5 w-5",
    title: "text-sm",
    subtitle: "text-xs",
    spacing: "space-y-2",
  },
  md: {
    spinner: "h-6 w-6",
    title: "text-sm",
    subtitle: "text-xs",
    spacing: "space-y-2",
  },
  lg: {
    spinner: "h-7 w-7",
    title: "text-base",
    subtitle: "text-sm",
    spacing: "space-y-2",
  },
};

const MainLoader = ({
  title = "Loading",
  subtitle,
  size = "lg",
  className,
}: MainLoaderProps) => {
  const styles = sizeStyles[size];

  return (
    <div className={cn("text-center", styles.spacing, className)}>
      <div className="flex justify-center">
        <Loader2 className={cn("animate-spin text-primary", styles.spinner)} aria-hidden="true" />
      </div>
      <div className="space-y-1">
        <p className={cn("font-medium text-foreground", styles.title)}>{title}</p>
        {subtitle ? <p className={cn("text-muted-foreground", styles.subtitle)}>{subtitle}</p> : null}
      </div>
    </div>
  );
};

export default MainLoader;
